<template>
  <div id="Legals" class="Page Legals" v-if="response">
      <PrismicRichText :field="response" :field-content="response" />
  </div>
</template>

<script>
import Vue from 'vue'
import page from "@/mixins/page"
import PrismicFetch from "@/mixins/prismicFetch"

import ScrollParallax from "@/components/ScrollParallax"
import Fade from "@/components/Fade"
import Footer from "@/components/partials/Footer"

export default {
  components: {
    ScrollParallax,
    Fade,
    Footer
  },
  mixins: [ page, PrismicFetch ],
  data () {
    return {
      data: null
    }
  },
  head: {
    title: {
      inner: "So Beautiful By Sarah",
      separator: '/',
      complement: 'Mentions légales'
    }
  },
  created () {
    this.getContent('legals')
      console.log(this.response)
  }
}
</script>

<style lang="stylus" scoped>
.Legals
  height: 100vh
  display flex
  padding-top: 140px
  justify-content center

  a:hover
    color $dark-brown

  &_wrapper
    padding 60px 0

    @media $xsmall
      padding 40px 0

  &_text
    color $dark-brown
    width 500px
    margin 0 auto
    text-align center
</style>
